<template>
	<div id="groups-search">
		<div v-if="step === 1" style="height:inherit">
			<input
				type="text"
				id="groups-searchBox"
				v-model="searchInput"
				@keyup="handleSearch"
				placeholder="Search for users..."
			/>
			<ion-icon name="ios-search"></ion-icon>
			<ion-icon v-if="showClear" name="close-circle-outline" @click="clearInput"></ion-icon>
			<br />
			<span v-if="!showLoader && matchedHits.length === 0" class="search-info">{{searchInfo}}</span>
			<!-- <span v-else-if="group.length > 0" class="search-info">{{group.length}} added</span> -->
			<div v-if="showLoader" class="loader-container groups-search-result">
				<loading v-if="showLoader"></loading>
			</div>
			<div class="users-list-container">
				<users-list
					@userAdded="addToGroup"
					@userRemoved="removeFromGroup"
					:from="componentName"
					:users="matchedHits"
				></users-list>
			</div>
			<div v-if="group.length > 0" class="selected-users-container">
				<span
					class="selected-info"
				>{{groupSelectCount}} {{groupSelectCount > 1 ? 'users' : 'user'}} selected</span>
				<ul class="selected-users">
					<groups-selected-users
						v-for="user in group"
						:user="user"
						:key="user.objectID"
						@userRemoved="removeFromGroup"
					></groups-selected-users>
				</ul>
			</div>
			<div v-if="group.length > 0" class="group-message-button">
				<hr />
				<div v-if="showGroupNameInput" class="group-name">
					<label>Group name:</label>
					<input
						type="text"
						placeholder="Enter group name"
						class="group-name-input"
						maxlength="15"
						minlength="2"
						v-model="groupName"
					/>
					<button
						v-if="showGroupSubmit"
						type="button"
						class="button stackng-button group-name-button"
						@click="goToNextStep"
					>Start group</button>
				</div>
				<button
					v-else
					type="button"
					class="button stackng-button group-name-button"
					@click="goToNextStep"
				>Start group</button>
			</div>
		</div>
		<div v-else-if="step === 2" style="height:inherit">
			<groups-message
				:groupID="groupID"
				:users="group"
				:groupName="groupName"
				:admin="groupAdmin"
				:dateCreated="groupDateCreated"
				:from="componentName"
				@goBack="goBack"
			></groups-message>
		</div>
	</div>
</template>

<script>
import { db } from "../../../resources/firebase";
import firebase from "firebase/app";
import "firebase/auth";
import algoliaSearch from "algoliasearch/lite";
import UsersList from "../../users/userView/UsersList.vue";
import GroupsSelectedUsers from "./GroupsSelectedUsers.vue";
import GroupsMessage from "../groupsMessage/GroupsMessage.vue";
import Loading from "../../errors/PageLoading.vue";
import { groupsMixin } from "../../../mixins/groupsMixin";
import { sendNotification } from "../../../api/notifications";

export default {
	mixins: [groupsMixin],
	data() {
		return {
			searchClient: algoliaSearch(
				"HU4XMG2UTE",
				"bc3645b95de77400a5d1053b0a97d946"
			),
			authUser: {},
			step: 1,
			searchInput: "",
			showClear: false,
			showLoader: false,
			searchInfo: "Search results will display here",
			componentName: "groups-search",
			matchedHits: [],
			group: [],
			groupID: "",
			groupName: "",
			groupAdmin: "",
			groupDateCreated: null,
			groupSelectCount: 0,
			showGroupNameInput: false,
			showGroupSubmit: false
		};
	},
	components: {
		UsersList,
		GroupsSelectedUsers,
		GroupsMessage,
		Loading
	},
	methods: {
		debounceHandleSearch() {
			let timer;
			return () => {
				clearTimeout(timer);
				timer = setTimeout(() => {
					this.handleSearch();
				}, 300);
			};
		},
		handleSearch() {
			if (this.searchInput !== "") {
				this.showClear = true;
				this.showLoader = true;
				let searchableUsers = this.$store.state.app.app.groupsModal
					.searchableUsers;
				setTimeout(() => {
					const index = this.searchClient.initIndex("users");

					index.search(
						{
							query: this.searchInput,
							attributesToRetrieve: [
								"firstName",
								"lastName",
								"username",
								"photoURL",
								"deleted"
							]
						},
						(err, { hits } = {}) => {
							if (err) throw err;

							var hit2 = [];
							if (hits.length > 0) {
								hits.forEach(item => {
									if (
										searchableUsers.includes(item.objectID) &&
										!this.groupContainsHit(item.objectID) &&
										!item.deleted
									) {
										hit2.push(item);
										this.matchedHits = hit2;
										this.showLoader = false;
									} else {
										this.showLoader = false;
										this.searchInfo = "No users match this search";
									}
								});
							} else {
								this.matchedHits = [];
								this.showLoader = false;
								this.searchInfo = "No users match this search";
							}
						}
					);
				}, 500);
			}
		},
		groupContainsHit(userID) {
			let test = this.group.some(item => {
				return item.objectID === userID;
			});

			return test;
		},
		clearInput() {
			this.searchInput = "";
			this.showClear = false;
			this.showLoader = false;
			this.matchedHits = [];
			this.searchInfo = "Search results will display here";
			this.handleSearch();
		},
		addToGroup(user) {
			//Remove _highlightResult property
			delete user._highlightResult;

			if (!this.groupContainsHit(user.objectID)) {
				this.group.push(user);
				this.groupSelectCount++;
				this.showGroupNameInput = this.group.length >= 6 ? true : false;

				//Remove from matchedHits
				let userToRemove = this.matchedHits.findIndex(item => {
					return item.objectID === user.objectID;
				});

				if (userToRemove > -1) this.matchedHits.splice(userToRemove, 1);
			}
		},
		removeFromGroup(user) {
			let userToRemove = this.group.findIndex(item => {
				return item.objectID === user.objectID;
			});
			if (userToRemove > -1) this.group.splice(userToRemove, 1);
			if (this.group.length === 0) this.groupSelectCount = 0;

			this.showGroupNameInput = this.group.length >= 6 ? true : false;
			this.groupSelectCount--;

			//Add back to matchedHits
			let userToAdd = this.matchedHits.findIndex(item => {
				return item.objectID === user.objectID;
			});

			if (userToAdd <= -1) this.matchedHits.push(user);
		},
		goBack(data) {
			if (data !== null && data !== undefined) {
				if (data.actionType === "delete") {
					//Remove group from user's groups in db
					// this.removeGroupFromAllUsers(this.group, data)

					let groupRemoved = new Promise((resolve, reject) => {
						resolve(this.removeGroupFromAllUsers(this.group, data));
					}).catch(error => {
						// console.log(error);
						reject(new Error(error));
					});

					const authUser = this.$store.state.user.authUser.uid;
					let memberIDs = this.group.map(item => item.objectID || item.userID);
					groupRemoved
						.then(() => {
							console.log("here");
							console.log(authUser, this.group, memberIDs);
							memberIDs.forEach(member => {
								if (member !== authUser) {
									//Add to all members notifications
									let notification = {
										type: "group-deleted",
										user: authUser,
										dateCreated: Date.now(),
										members: memberIDs.length >= 7 ? this.groupName : memberIDs,
										seen: false
									};

									sendNotification(member, notification);
								}
							});
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});
				} else if (data.actionType === "leave") {
					//Remove group from authUser groups in db
					this.removeGroupFromAuthUser(data);
				}

				this.step = 1;
				this.groupName = "";
				this.group = [];
				this.groupID = "";
				this.groupAdmin = "";
				this.groupDateCreated = null;
				this.groupSelectCount = 0;

				return;
			}

			// DO NOT NEED?
			//remove authUser from group
			let userToRemove = this.group.findIndex(item => {
				return item.objectID === this.authUser.objectID;
			});
			if (userToRemove > -1) this.group.splice(userToRemove, 1);

			this.step = 1;
			this.groupName = "";

			let groupModalTite = window.document.querySelector(".modal-title span");
			groupModalTite.style.marginLeft = "0px";
		},
		goToNextStep() {
			const startButton = document.querySelector(".group-name-button");
			startButton.classList.add("is-loading");

			this.authUser.firstName = this.$store.state.user.user.firstName;
			this.authUser.lastName = this.$store.state.user.user.lastName;
			this.authUser.objectID = this.$store.state.user.authUser.uid;
			this.authUser.photoURL = this.$store.state.user.user.photoURL;
			this.authUser.username = this.$store.state.user.user.username;

			//Add authUser to group
			let userToAdd = this.group.findIndex(item => {
				return item.objectID === this.authUser.objectID;
			});

			if (userToAdd <= -1) this.group.unshift(this.authUser);

			let groupMembers = this.group.map(item => item.objectID);

			this.checkIfGroupExists(groupMembers);
		},
		checkIfGroupExists(newMembers) {
			let authUserGroups = this.$store.state.user.user.groups;
			let allGroupMembers = [];
			const startButton = document.querySelector(".group-name-button");

			if (authUserGroups && authUserGroups.length > 0) {
				function getExistingMembers(group) {
					return new Promise((resolve, reject) => {
						db.collection("test_groups")
							.doc(group)
							.get()
							.then(doc => {
								//Check if any element in group members is an object so we can extract the ID else push the ID
								let newMembersList = doc.data().members.map(item => {
									if (typeof item === "object") {
										return item.objectID;
									} else {
										return item;
									}
								});

								resolve(newMembersList);
							})
							.catch(error => {
								// console.log(error);
								reject(new Error(error));
							});
					});
				}

				authUserGroups.forEach(group => {
					allGroupMembers.push(getExistingMembers(group));
				});

				Promise.all(allGroupMembers).then(all => {
					for (let i = 0; i < all.length; i++) {
						//Check if existing members is equal to newMembers
						if (!this.areMembersTheSame(all[i], newMembers)) {
							//Should not break
							if (i === all.length - 1) {
								this.addNewGroup(newMembers);
								startButton.classList.remove("is-loading");
							}
						} else {
							//Should break, group already exists
							startButton.classList.remove("is-loading");

							//Show toast
							this.$toasted.show(`Group exists`, {
								theme: "bubble",
								position: "bottom-center",
								duration: 2500,
								className: ["error-toast"]
							});

							this.group = [];
							this.groupSelectCount = 0;
							this.matchedHits = [];
							// this.searchInput = ""
							this.searchInfo = "Group already exists";

							break;
						}
					}
				});
			} else {
				this.addNewGroup(newMembers);
				startButton.classList.remove("is-loading");
			}
		},
		addNewGroup(newMembers) {
			// Add group to db
			db.collection("test_groups")
				.add({
					admin: this.$store.state.user.authUser.uid,
					members: newMembers, //passed this.group before
					groupName: this.groupName,
					dateCreated: firebase.firestore.FieldValue.serverTimestamp()
				})
				.then(docRef => {
					this.groupID = docRef.id;

					//Update group id with doc id
					db.collection("test_groups")
						.doc(docRef.id)
						.update({
							groupID: docRef.id
						})
						.then(() => {
							//Update all members groups array
							newMembers.forEach(member => {
								db.collection("users")
									.doc(member)
									.update({
										groups: firebase.firestore.FieldValue.arrayUnion(docRef.id)
									})
									.then(() => {
										//Add to member's notifications if member ID is not authUser id
										if (member !== this.authUser.objectID) {
											//Add to all members notifications
											let notification = {
												type: "group-created",
												user: this.authUser.objectID,
												dateCreated: Date.now(),
												members:
													newMembers.length >= 7 ? this.groupName : newMembers,
												group: docRef.id,
												seen: false
											};

											sendNotification(member, notification);
										}
									})
									.catch(error => {
										// console.log(error);
										//Show toast
										this.$toasted.show(`An error occured`, {
											theme: "bubble",
											position: "bottom-center",
											duration: 2500,
											className: ["error-toast"]
										});

										throw new Error(error);
									});
							});
						})
						.catch(error => {
							// console.log(error);
							//Show toast
							this.$toasted.show(`An error occured`, {
								theme: "bubble",
								position: "bottom-center",
								duration: 2500,
								className: ["error-toast"]
							});

							throw new Error(error);
						});

					//Show toast
					this.$toasted.show(`Group created`, {
						theme: "bubble",
						position: "bottom-center",
						duration: 2500
					});

					//Update user groups state
					this.$store.commit("addGroup", docRef.id);

					//Set payload
					let payload = {
						group: this.group
					};

					//Set state
					this.$store.commit("updateGroupsModal", payload);

					//Set admin
					this.groupAdmin = this.$store.state.user.authUser.uid;

					//Set date created
					db.collection("test_groups")
						.doc(docRef.id)
						.get()
						.then(doc => {
							this.groupDateCreated = doc.data().dateCreated;
						})
						.catch(error => {
							// console.log(error);
							throw new Error(error);
						});

					//Go to next step
					this.step = 2;
				})
				.catch(error => {
					// console.log(error);
					//Show toast
					this.$toasted.show(`An error occured`, {
						theme: "bubble",
						position: "bottom-center",
						duration: 2500,
						className: ["error-toast"]
					});

					throw new Error(error);
				});
		},
		areMembersTheSame(existingMembers, newMembers) {
			if (existingMembers.length !== newMembers.length) return false;

			let match = [];
			existingMembers.forEach(member => {
				if (newMembers.indexOf(member) > -1) {
					match.push(member);
				}
			});

			if (match.length === existingMembers.length) {
				return true;
			} else {
				return false;
			}
		}
	},
	watch: {
		searchInput(val) {
			if (val === "") {
				this.showClear = false;
				this.showLoader = false;
				this.matchedHits = [];
				this.searchInfo = "Search results will display here";
			} else {
				this.showClear = true;
			}
		},
		groupName(val) {
			this.showGroupSubmit = val.length >= 2 ? true : false;
		}
	}
};
</script>

<style scoped>
#groups-search {
	position: relative;
	height: 100%;
	margin-top: 10px;
}

#groups-search input {
	width: 100%;
	padding: 13px 15px 15px 45px;
	font-size: 13px;
	margin-bottom: 15px;
}

#groups-search ion-icon[name="ios-search"] {
	font-size: 20px;
	position: absolute;
	left: 15px;
	top: 12px;
}

#groups-search ion-icon[name="close-circle-outline"] {
	font-size: 20px;
	position: absolute;
	right: 15px;
	top: 15px;
	cursor: pointer;
}

.search-info,
.selected-info {
	display: block;
	text-align: center;
	color: #b7b7b7;
	font-size: 11px;
}

.selected-info {
	text-align: left;
}

.loader-container {
	position: relative;
	height: 30px;
}

.users-list-container {
	position: relative;
	max-height: 270px;
	overflow: auto;
}

.selected-users-container {
	border-top: 1px solid #111;
	padding-top: 20px;
	margin-top: 20px;
}

.selected-users {
	display: flex;
	flex-wrap: wrap;
	margin-top: 5px;
}

.group-message-button {
	position: absolute;
	bottom: 40px;
	width: 100%;
}

.stackng-button {
	padding: 10px 20px 12px 20px;
	font-size: 15px;
	width: 100%;
}

.group-name {
	display: block;
	/* width: 70%; */
	margin: auto;
}

.group-name label {
	display: block;
	width: fit-content;
}

/* .group-name button {
		margin-top: 10px;
		display: block;
		margin: 10px auto 0;
	} */

.group-name-input {
	padding: 13px 15px 15px 13px !important;
	font-size: 15px;
	margin-bottom: 5px !important;
}

.group-name-button {
	margin-top: 10px;
}

hr {
	background-color: #111;
	height: 1px;
}

ion-icon {
	color: #fff;
}

@media only screen and (max-width: 768px) {
	.stackng-button {
		width: 100%;
	}

	.group-name {
		width: 100% !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/groups/groupsSearch/GroupsSearch.vue